"use strict";

var _createForOfIteratorHelper = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\muham\\Desktop\\iola_web\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var idlUtils = require("../generated/utils.js");

var _require = require("../helpers/namespaces"),
    HTML_NS = _require.HTML_NS;

exports.implementation = /*#__PURE__*/function () {
  function HTMLCollectionImpl(args, privateData) {
    _classCallCheck(this, HTMLCollectionImpl);

    this._list = [];
    this._version = -1;
    this._element = privateData.element;
    this._query = privateData.query;

    this._update();
  }

  _createClass(HTMLCollectionImpl, [{
    key: "item",
    value: function item(index) {
      this._update();

      return this._list[index] || null;
    }
  }, {
    key: "namedItem",
    value: function namedItem(key) {
      if (key === "") {
        return null;
      }

      this._update();

      var _iterator = _createForOfIteratorHelper(this._list),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var element = _step.value;

          if (element.getAttributeNS(null, "id") === key) {
            return element;
          }

          if (element._namespaceURI === HTML_NS) {
            var name = element.getAttributeNS(null, "name");

            if (name === key) {
              return element;
            }
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      return null;
    }
  }, {
    key: "_update",
    value: function _update() {
      if (this._version < this._element._version) {
        var snapshot = this._query();

        for (var i = 0; i < snapshot.length; i++) {
          this._list[i] = snapshot[i];
        }

        this._list.length = snapshot.length;
        this._version = this._element._version;
      }
    }
  }, {
    key: Symbol.iterator,
    // Inherit some useful functions from Array.
    value: function value() {
      this._update();

      return this._list[Symbol.iterator]();
    }
  }, {
    key: "entries",
    value: function entries() {
      this._update();

      return this._list.entries();
    }
  }, {
    key: "filter",
    value: function filter() {
      var _this$_list;

      this._update();

      return (_this$_list = this._list).filter.apply(_this$_list, arguments);
    }
  }, {
    key: "map",
    value: function map() {
      var _this$_list2;

      this._update();

      return (_this$_list2 = this._list).map.apply(_this$_list2, arguments);
    }
  }, {
    key: "indexOf",
    value: function indexOf() {
      var _this$_list3;

      this._update();

      return (_this$_list3 = this._list).indexOf.apply(_this$_list3, arguments);
    }
  }, {
    key: "length",
    get: function get() {
      this._update();

      return this._list.length;
    }
  }, {
    key: idlUtils.supportedPropertyIndices,
    get: function get() {
      this._update();

      return this._list.keys();
    }
  }, {
    key: idlUtils.supportedPropertyNames,
    get: function get() {
      this._update();

      var result = new Set();

      var _iterator2 = _createForOfIteratorHelper(this._list),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var element = _step2.value;
          var id = element.getAttributeNS(null, "id");

          if (id) {
            result.add(id);
          }

          if (element._namespaceURI === HTML_NS) {
            var name = element.getAttributeNS(null, "name");

            if (name) {
              result.add(name);
            }
          }
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return result;
    }
  }]);

  return HTMLCollectionImpl;
}();